<template>
    <div class="card col mx-4 mt-2">
        <div class="card-body">
            <div class="stat-widget-five grid">
                <div class="stat-icon flex justify-content-start mx-2"
                    :class="colorClass"    
                >
                    <span class="material-icons mr-3">{{icon}}</span>
                    <div class="text-xl font-bold">{{title}}</div>
                </div>
                <div class="stat-content flex align-items-center">
                    <div class="text-left">
                        <div class="stat-text"><span class="flex text-surface-900 text-5xl font-semi-bold mt-1">{{value}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default  defineComponent({
    name: 'StatCard',
    
    props: [
        'icon',
        'value',
        'title',
        'pending',
        'colorClass'
    ],
    data(){
        return {
            data: this.value,
            pendingValue: this.pending
        }
    },
    computed: {
        
    },
    methods: {
    
    },
    watch:{
        value(newVal) {
            this.data = newVal;
        },
        pending(){
            if(this.pending){
                this.pendingValue = this.pending
            }
        }
    }
})
</script>
<style src="./stat-card.scss" lang="scss" scoped></style>